import { createSSRApp } from 'vue';
import { createHead } from '@vueuse/head';
import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import fr from '@/locales/fr.json';
import PublicApp from '@/static/PublicApp.vue';
import { applyRouteLocale, createPublicRouter } from '@/static/publicRouter.js';
import './assets/public.css';

const i18n = createI18n({
    legacy: false,
    fallbackLocale: 'en',
    messages: { en, fr },
});
const router = createPublicRouter();
applyRouteLocale(router, i18n);

const app = createSSRApp(PublicApp);
app.use(createHead());
app.use(router);
app.use(i18n);

router.isReady().then(() => app.mount('#app'));
